function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { SelectedState } from "../../lib/selected-state.js";
import { titleCase, formatCurrency } from "../../lib/utils.js";
import { html } from "lit";
import { property, customElement } from "lit/decorators.js";
import "../../common/legal-disclaimer.js";
import "../../common/descriptor-list.js";
import "../../common/promotional-description.js";
import "../../common/offer-header.js";
import "../../common/landing-page-action.js";
import { when } from "lit/directives/when.js";
import { MultiOfferQuoteElement } from "../../lib/multi-offer-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var GapMedical = /*#__PURE__*/function (_MultiOfferQuoteEleme) {
  _inherits(GapMedical, _MultiOfferQuoteEleme);

  var _super = _createSuper(GapMedical);

  function GapMedical() {
    _classCallCheck(this, GapMedical);

    return _super.call(this, "gap-medical");
  }
  /**
   * @ignore
   */


  _createClass(GapMedical, [{
    key: "_renderMultiDisplay",
    value: function _renderMultiDisplay() {
      var _this = this;

      var _a, _b, _c, _d, _e;

      return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <offer-checkbox-button @change=", " ?checked=", ">\n        <div class=\"multi-offer-item\">\n          <div>Include <strong>", "</strong> Package for ", " ", " ", "</div>\n          <div>", "</div>\n        </div>\n      </offer-checkbox-button>\n    "])), this.toggleOfferSelection, this.selectedState === SelectedState.ACCEPTED, titleCase(this.coverageType), this.participantFirstName, this.participantLastName, when(this.coverageContextDescription, function () {
        return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["(", ")"])), _this.coverageContextDescription);
      }), ((_a = this.quote) == null ? void 0 : _a.total) || ((_b = this.quote) == null ? void 0 : _b.premium_amount) ? formatCurrency(((_c = this.quote) == null ? void 0 : _c.total) || ((_d = this.quote) == null ? void 0 : _d.premium_amount), (_e = this.quote) == null ? void 0 : _e.currency) : "");
    }
    /**
     * @ignore
     */

  }, {
    key: "policyAttributes",
    get: function get() {
      return {
        covered_person: {
          first_name: this.participantFirstName,
          last_name: this.participantLastName,
          state: this.participantState,
          street: this.participantStreetAddress,
          birth_date: this.participantBirthDate
        },
        coverage_type: this.coverageType,
        coverage_start_date: this.coverageStartDate,
        coverage_end_date: this.coverageStartDate
      };
    }
  }]);

  return GapMedical;
}(MultiOfferQuoteElement);

GapMedical.styles = [MultiOfferQuoteElement.styles];

__decorateClass([property({
  attribute: "coverage-type"
})], GapMedical.prototype, "coverageType", 2);

__decorateClass([property({
  attribute: "coverage-start-date"
})], GapMedical.prototype, "coverageStartDate", 2);

__decorateClass([property({
  attribute: "coverage-end-date"
})], GapMedical.prototype, "coverageEndDate", 2);

__decorateClass([property({
  attribute: "participant-first-name"
})], GapMedical.prototype, "participantFirstName", 2);

__decorateClass([property({
  attribute: "participant-last-name"
})], GapMedical.prototype, "participantLastName", 2);

__decorateClass([property({
  attribute: "participant-street-address"
})], GapMedical.prototype, "participantStreetAddress", 2);

__decorateClass([property({
  attribute: "participant-state"
})], GapMedical.prototype, "participantState", 2);

__decorateClass([property({
  attribute: "participant-birth-date"
})], GapMedical.prototype, "participantBirthDate", 2);

GapMedical = __decorateClass([customElement("gap-medical")], GapMedical);
export { GapMedical };